import React from "react";
import { Col, Row } from "reactstrap";

class Badges extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Row>
        <Col md="3" sm="6" xs="6">
          <p className="Bookmark">
            <i className="fas fa-bookmark"></i>
            <p>
              <i className="fas fa-lock"></i>
            </p>
            <h6 className="Description-header">Secure</h6>
            <p className="Description">
              Ensuring that I always ship software that is secure, is my
              greatest concern
            </p>
          </p>
        </Col>
        <Col md="3" sm="6" xs="6">
          <p className="Bookmark">
            <i className="fas fa-bookmark"></i>
            <p>
              <i className="far fa-paper-plane"></i>
            </p>
            <h6 className="Description-header">Fast</h6>
            <p className="Description">
              High execution speeds and little to zero downtime, my priority.
            </p>
          </p>
        </Col>
        <Col md="3" sm="6" xs="6">
          <p className="Bookmark">
            <i className="fas fa-bookmark"></i>
            <p>
              <i className="fas fa-sitemap"></i>
            </p>
            <h6 className="Description-header">Scalable</h6>
            <p className="Description">
              Strong preference for easily scalable applications
            </p>
          </p>
        </Col>
        <Col md="3" sm="6" xs="6">
          <p className="Bookmark">
            <i className="fas fa-bookmark"></i>
            <p>
              <i className="fas fa-tasks"></i>
            </p>
            <h6 className="Description-header">Intuitive</h6>
            <p className="Description">
              Always shipping software with the end user in mind
            </p>
          </p>
        </Col>
      </Row>
    );
  }
}

export default Badges;
